import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import Categories from '../components/home/Categories';
import TrendingTools from '../components/home/TrendingTools';
import Features from '../components/home/Features';
import FeaturedBlogs from '../components/home/FeaturedBlogs';
import Testimonials from '../components/home/Testimonials';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <TrendingTools />
        <Features />
        <FeaturedBlogs />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default Home;